import { memo } from "react";
import PropTypes from "prop-types";
import Page from "app/pages/.shared/Page/Page";
import Separator from "app/pages/.shared/Separator";
import "./StaticPage.scss";
import LoaderBar from "app/pages/.shared/LoaderBar/LoaderBar";

import { DynamicBlocksRendererContainer } from "app/pages/.shared/DynamicBlocks";

const StaticPage = ({ blocks = [], title }) => {
	return (
		<div className="static-page">
			{blocks.length > 0 ? (
				<Page title={title}>
					<DynamicBlocksRendererContainer
						blocks={blocks}
						DividerComponent={<Separator design="middle" />}
					/>
				</Page>
			) : (
				<Page>
					<div className="static-page__placeholder">
						<LoaderBar />
						<LoaderBar />
						<LoaderBar />
						<LoaderBar />
						<LoaderBar />
						<LoaderBar />
						<LoaderBar />
						<LoaderBar />
						<LoaderBar />
						<LoaderBar />
						<LoaderBar />
						<LoaderBar />
					</div>
				</Page>
			)}
		</div>
	);
};

StaticPage.propTypes = {
	blocks: PropTypes.array,
	title: PropTypes.string,
};

export default memo(StaticPage);
